import { render, staticRenderFns } from "./NotificationWalletAction.vue?vue&type=template&id=0838f518"
import script from "./NotificationWalletAction.vue?vue&type=script&lang=js"
export * from "./NotificationWalletAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports